import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana9Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
    <rect width="1221" height="921" fill="url(#pattern0_1467_35425)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M734.81 287.727H657.598L638.765 310.325L700.912 361.172L742.343 310.325C745.356 295.259 738.576 288.982 734.81 287.727Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M665.13 404.486L700.912 361.172L638.765 310.325L604.867 353.639L665.13 404.486Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M569.08 287.727H657.592L599.212 361.172L546.482 314.092L569.08 287.727Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M627.467 447.802L665.132 404.488L604.869 353.641L570.971 395.072L627.467 447.802Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M505.054 359.289L546.485 314.092L599.215 361.172L557.784 410.136L505.054 359.289Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M589.802 489.229L627.466 447.798L570.97 395.067L531.422 438.382L589.802 489.229Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M461.735 406.369L505.049 359.288L557.78 410.135L514.465 455.333L461.735 406.369Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M550.254 530.664L589.802 489.233L531.422 438.386L493.758 477.933L550.254 530.664Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M418.428 453.449L461.742 406.368L514.472 455.332L469.275 504.296L418.428 453.449Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M512.587 570.209L550.252 530.661L493.755 477.931L457.974 515.595L512.587 570.209Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M375.109 496.763L418.424 453.449L469.271 504.296L424.073 549.494L375.109 496.763Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M471.158 609.757L512.589 570.209L457.976 515.596L418.428 555.143L471.158 609.757Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M431.612 647.424L471.159 609.76L418.429 555.146L376.998 592.811L431.612 647.424Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M329.913 541.962L375.11 496.765L424.074 549.495L376.994 592.809L329.913 541.962Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M275.297 590.928L329.91 541.964L365.694 581.512L311.081 630.475L277.18 617.293C265.127 608.253 270.903 595.95 275.297 590.928Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M405.246 664.371L311.085 630.473L365.698 581.509L431.611 647.422L416.545 664.371C415.039 665.877 408.385 664.998 405.246 664.371Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_35425" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_35425" transform="matrix(0.00258315 0 0 0.00342457 -5.98099 -0.845696)"/>
    </pattern>
    <image id="image0_1467_35425" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};